import _OneSignal from "onesignal-cordova-plugin";

const OneSignal: typeof _OneSignal = (_OneSignal as any).default ?? _OneSignal;

export default OneSignal;
export type { NotificationClickEvent } from "onesignal-cordova-plugin";
